import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ title, subtitle, icon, linkTo, linkLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
            <i className={`${icon} text-lg`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}